<template>
  <card-modal-component
    :show="show_modal"
    @deactivate="toggleModal()"
    transition="fade"
    ref="recommendCaseModal"
    :options="{ hasOkBtn: { text: 'Save' }, hasCancelBtn: { enabled: true }}"
    @handleOk="submitComment($event)"
    @handleCancel="toggleModal()"
    :title="`Recommend case`">
    <form-component
      slot="card-content"
      v-for="formDescriptor in formDescriptors"
      :formDescriptor="formDescriptor"
      :formData="getFormDataForDescriptor(formDescriptor)"
      :key="formDescriptor.id">
    </form-component>
  </card-modal-component>
</template>
<script>

  import { mapState, mapActions } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import { formHandlerMixin } from '@/mixins/mixins'
  import { globalEventBus } from '@/utility/utility_functions'

  export default {
    name: 'recommend-case-modal-component',
    mixins: [formHandlerMixin],
    components: {
      FormComponent,
      CardModalComponent
    },
    data () {
      return {
        show_modal: false,
        recommendationType: null
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.caseModule.closeCaseFormDescriptor,
        formDatas: state => state.caseModule.closeCaseFormData,
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'setCase',
        'setupRecommendCaseForm',
        'saveRecommendCaseForm'
      ]),
      toggleHandler (event) {
        this.recommendationType = event.type
        this.toggleModal(event.btn)
      },
      toggleModal (btn) {
        btn && btn.enable()
        this.show_modal = !this.show_modal
      },
      submitComment (btn) {
        let requestData = {
          caseId: this.caseId,
          formDatas: this.formDatas,
          type: this.recommendationType
        }
        this.submitRequest = this.saveRecommendCaseForm
        this.submitForm(requestData, btn, this.submitCommentCallback)
      },
      submitCommentCallback () {
        this.show_modal = false
        this.$refs.recommendCaseModal.closeModal().then(() => {
          this.setCase(this.caseId).then(() => {
            this.$emit('onRecommend')
          }).catch((err) => {
            this.handleError(err)
          })
        })
      }
    },
    created () {
      globalEventBus.$on('recommend-case-toggle-modal', this.toggleHandler)
      this.setupRecommendCaseForm(this.caseId).catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>
